import { render, staticRenderFns } from "./AnnotationProfileProjectionTable.vue?vue&type=template&id=6ac467f4&scoped=true&"
import script from "./AnnotationProfileProjectionTable.vue?vue&type=script&lang=js&"
export * from "./AnnotationProfileProjectionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac467f4",
  null
  
)

export default component.exports